import z from 'zod';

import { TeamId, UserId } from '../../BrandedIds';
import { zodTemporalInstant } from '../../Temporal';
import { CompanyRole, UserName } from '../../User';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportableUser = z
  .object({
    id: zodBrandedString<UserId>(),
    email: z.string(),
    ssoEmail: z.string().optional(),
    name: UserName.optional(),

    companyRole: CompanyRole,
    teams: zodBrandedUuid<TeamId>().array(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'User' });
export type ExportableUser = z.infer<typeof ExportableUser>;
